import { gql, useMutation } from '@apollo/client'
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { environment } from 'constants/environment'

const VERIFY_INVISIBLE_RECAPTCHA = gql`
  mutation verifyInvisibleRecaptcha($token: String!) {
    verifyInvisibleRecaptchaToken(token: $token) {
      isSuccess
    }
  }
`

export const InvisibleRecaptcha = forwardRef((props, ref) => {
  const recaptchaRef = useRef(null)
  const [verifyToken] = useMutation(VERIFY_INVISIBLE_RECAPTCHA, {
    context: { isPublic: true },
  })
  const [isLoaded, setIsLoaded] = useState(false)

  useImperativeHandle(ref, () => ({
    execute: async () => {
      try {
        if (!recaptchaRef.current) {
          // eslint-disable-next-line no-console
          console.error('InvisibleRecaptcha: ref is null', { isLoaded })
          return false
        }

        const token = await recaptchaRef.current.executeAsync()
        if (!token) {
          // eslint-disable-next-line no-console
          console.error('InvisibleRecaptcha: executeAsync returned no token')
          return false
        }

        const { data: { verifyInvisibleRecaptchaToken } = {}, errors } =
          await verifyToken({
            variables: { token },
          })

        if (errors) {
          // eslint-disable-next-line no-console
          console.error(
            'InvisibleRecaptcha: verification mutation returned errors',
            errors
          )
          return false
        }

        if (!verifyInvisibleRecaptchaToken?.isSuccess) {
          // eslint-disable-next-line no-console
          console.error('InvisibleRecaptcha: verification failed', {
            verifyInvisibleRecaptchaToken,
          })
          return false
        }

        return true
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(
          'InvisibleRecaptcha: unexpected error during execute',
          err
        )
        return false
      }
    },
  }))

  return (
    <div key="invisibleRecaptchaKey">
      {typeof window !== 'undefined' && (
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={environment.G_RECAPTCHA_V2_API_KEY}
          asyncScriptOnLoad={() => setIsLoaded(true)}
          onErrored={() => {
            // eslint-disable-next-line no-console
            console.error('InvisibleRecaptcha: ReCAPTCHA script failed to load')
          }}
        />
      )}
    </div>
  )
})
